import type { EndpointsServiceParams } from '@wiosna-dev/wiosna-ui/types'

const endpointServiceParams: EndpointsServiceParams = {
  apiVersion: 'v1',
  testCafeUrl: import.meta.env.VITE_APP_API_BASE_TESTCAFE_URL,
  baseUrl: import.meta.env.VITE_APP_API_URL
}

export default endpointServiceParams
